import React, { Component } from 'react';
import { Row, Col } from "antd";
import ADR from "./ADR";
import FB from "./FB";
import Market from "./Market";
import REV from "./REV";
import Revenue from "./Revenue";
import Room from "./Room";
import Title from "./title";
import "./index.scss";

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {}
        }
    }

    componentDidMount() {
        fetch('/bi_statistics', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({
                data: x.data || {}
            });
        }).catch(err => {
            console.error(err);
        })
    }

    render() {
        return (
            <div className="BI_chart">
                <Title data={this.state.data} />
                <Row>
                    <Col span={12} className="bizcharts_bck">
                        <ADR data={this.state.data} />
                    </Col>
                    <Col span={12} className="bizcharts_bck">
                        <Room data={this.state.data} />
                    </Col>
                </Row>
                <Row>
                    <Col span={12} className="bizcharts_bck">
                        <FB data={this.state.data} />
                    </Col>
                    <Col span={12} className="bizcharts_bck">
                        <Revenue data={this.state.data} />
                    </Col>
                </Row>
                <Row>
                    <Col span={12} className="bizcharts_bck">
                        <REV data={this.state.data} />
                    </Col>
                    <Col span={12} className="bizcharts_bck">
                        <Market data={this.state.data} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/BI/home/index.js